export const AMENTI_AUTH_RETURN_TO_SESSION_KEY = 'amenti:authReturnTo';

export const getAmentiAuthReturnTo = () => {
  const sessionStorageItem = `${sessionStorage.getItem(AMENTI_AUTH_RETURN_TO_SESSION_KEY)}`;
  return sessionStorageItem?.startsWith('/') ? sessionStorageItem : '/';
};
